import { Link } from 'react-router-dom';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#f8f6f4]">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-[#f8f6f4] border-b border-gray-200">
        <Link to="/" className="text-xl font-bold tracking-wide">
          <span className="text-black">★</span> Top Data
        </Link>
        <Link
          to="/"
          className="text-sm text-gray-600 hover:text-black transition"
        >
          Back to Home
        </Link>
      </header>

      {/* Main Content */}
      <main className="flex items-center justify-center min-h-[calc(100vh-73px)] px-6">
        <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
          <h1 className="text-3xl font-bold text-black mb-6 viga-regular">
            Contact Us
          </h1>

          <div className="mb-8">
            <p className="text-gray-600 mb-6 zen-regular">
              Need help or have questions? Get in touch with us!
            </p>

            <div className="space-y-4">
              <div className="flex items-center justify-center space-x-3">
                <svg
                  className="w-6 h-6 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href="tel:0507653720"
                  className="text-2xl font-bold text-blue-600 hover:text-blue-700 transition"
                >
                  0507653720
                </a>
              </div>

              <p className="text-sm text-gray-500 mt-2">
                WhatsApp us for support and inquiries
              </p>
            </div>
          </div>

          <Link
            to="/"
            className="inline-block bg-black text-white px-8 py-3 rounded-md font-medium hover:bg-gray-800 transition"
          >
            Go to Home
          </Link>
        </div>
      </main>
    </div>
  );
}
